export default __webpack_public_path__ + "static/media/Notify_Icon.cc8d3a23.svg";